import React from "react";
import * as PropTypes from "prop-types";
import { Menu } from "antd";
import {
  LineChartOutlined,
  AreaChartOutlined,
  BarChartOutlined,
  PieChartOutlined,
  TableOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useIntl } from "react-intl";
import ButtonDropdown from "./ButtonDropdown";

const SelectChartType = ({ chartType, updateChartType }) => {
  const intl = useIntl();
  const ChartTypes = [
    {
      name: "line",
      title: intl.formatMessage({
        id: "app.reports.line",
      }),
      icon: <LineChartOutlined />,
    },
    {
      name: "area",
      title: intl.formatMessage({
        id: "app.reports.area",
      }),
      icon: <AreaChartOutlined />,
    },
    {
      name: "bar",
      title: intl.formatMessage({
        id: "app.reports.bar",
      }),
      icon: <BarChartOutlined />,
    },
    {
      name: "pie",
      title: intl.formatMessage({
        id: "app.reports.pie",
      }),
      icon: <PieChartOutlined />,
    },
    {
      name: "table",
      title: intl.formatMessage({
        id: "app.reports.table",
      }),
      icon: <TableOutlined />,
    },
    {
      name: "number",
      title: intl.formatMessage({
        id: "app.reports.number",
      }),
      icon: <InfoCircleOutlined />,
    },
  ];

  const menu = () => {
    const items = ChartTypes.map((i) => {
      return {
        label: (
          <div>
            {i.icon} {i.title}
          </div>
        ),
        key: i.title,
        onClick: (k) => {
          updateChartType(i.name);
        },
      };
    });

    return items;
  };

  const foundChartType = ChartTypes.find((t) => t.name === chartType);
  return (
    <ButtonDropdown
      items={menu()}
      icon={foundChartType.icon}
      style={{ border: 0 }}
    >
      {foundChartType.title}
    </ButtonDropdown>
  );
};

SelectChartType.propTypes = {
  chartType: PropTypes.string.isRequired,
  updateChartType: PropTypes.func.isRequired,
};

export default SelectChartType;
